export default "__VITE_ASSET__c3a55a54__"